import React, { useState } from "react";
import Testbook from "../../assets/login/testbookimg.png";
import { IoClose } from "react-icons/io5";
import Login from "../../assets/login/loginlogo.svg";
import OTP from "./OTP";
import { axiosRequest } from "../../_config/apiClient";

const Signup = ({ isOpen, onClose }) => {
    const [loginMethod, setLoginMethod] = useState("email");
    const [showOtp, setShowOtp] = useState(false);
    const [identifier, setIdentifier] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");


    if (!isOpen) return null;

    const isValidEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);

    const isValidIndianMobile = (mobile) =>
        /^[6-9]\d{9}$/.test(mobile);


    const handleContinue = async () => {
        setError("");

        if (!identifier.trim()) {
            setError("Email or mobile number is required");
            return;
        }

        if (loginMethod === "email" && !isValidEmail(identifier)) {
            setError("Please enter a valid email address");
            return;
        }

        if (loginMethod === "mobile" && !isValidIndianMobile(identifier)) {
            setError("Enter valid 10-digit Indian mobile number");
            return;
        }

        try {
            setLoading(true);

            const payload = loginMethod === 'email' ?
                { email: identifier.trim() } :
                { phone: identifier.trim() }


            const res = await axiosRequest('post', "/user/userRegister", payload);

            if (!res?.error) {
                sessionStorage.setItem('user', res.data.token)
                setShowOtp(true);
            } else {
                setError(res?.data?.message || "Something went wrong");
            }
        } catch (err) {
            setError(
                err?.message ||
                "Server error, please try again"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[999] px-4">
                <div className="w-full max-w-[1200px] py-6 px-4 sm:px-8 md:px-20 mx-auto rounded-[10px] bg-white relative">

                    <button
                        onClick={onClose}
                        className="absolute top-4 w-[24px] h-[24px] cursor-pointer flex items-center right-4 justify-center hover:text-gray-600 z-10 bg-white rounded-full p-1 border border-[#333333]"
                    >
                        <IoClose className="text-[#333333] text-[20px]" />
                    </button>

                    <div className="bg-white h-[600px] overflow-y-auto w-full mx-auto rounded-2xl max-w-[1100px] items-center grid grid-cols-1 lg:grid-cols-2">
                        <div className="flex-1 p-0 md:pr-18 lg:pr-30 pl-0 md:pl-2">
                            <img src={Login} alt="BaapBola Logo" />

                            <div className="mt-10">
                                <h2 className="text-[23px] md:text-[28px] font-[600] text-[#333333] tracking-tight mb-2">
                                    Get Started with BaapBola
                                </h2>

                                <p className="text-[16px] text-[#33333399] tracking-tight font-[500] leading-[20px]">
                                    Please enter your registered {" "}
                                    <span
                                        className={`${loginMethod === "email" ? "text-[#333333]" : "text-[#4096F6]"} cursor-pointer hover:underline`}
                                        onClick={() => { setLoginMethod("email"); setError(""); }}
                                    >
                                        Email
                                    </span>{" "}
                                    or{" "}
                                    <span
                                        className={`${loginMethod === "mobile" ? "text-[#333333]" : "text-[#4096F6]"} cursor-pointer hover:underline`}
                                        onClick={() => { setLoginMethod("mobile"); setError(""); }}
                                    >
                                        Mobile Number
                                    </span>
                                    {" "} along with your Subscriptionword to continue.
                                </p>
                            </div>

                            <div className="space-y-1 mt-10">
                                <div>
                                    <label className="block text-[18px] font-[500] text-[#333333] mb-2">
                                        {loginMethod === "email" ? "Email" : "Mobile Number"}
                                    </label>
                                    <input
                                        type={loginMethod === "email" ? "email" : "tel"}
                                        value={identifier}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            setError("");
                                            if (loginMethod === "mobile") {
                                                value = value.replace(/\D/g, "");
                                                if (value.length > 10) return;
                                                setIdentifier(value);
                                            } else {
                                                setIdentifier(value);
                                            }
                                        }}
                                        placeholder="Enter Here"
                                        className={`w-full border-[2.1px] rounded-[4px] px-4 py-3 tracking-tight font-[500] outline-none transition-all ${error ? "border-red-500" : "border-[#33333399] focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            }`}
                                    />
                                </div>

                                <div className="h-5">
                                    {error && (
                                        <p className="text-red-500 text-[13px] font-[500]">
                                            {error}
                                        </p>
                                    )}
                                </div>

                                <button
                                    onClick={handleContinue}
                                    disabled={loading}
                                    className={`w-full text-white font-semibold py-3 rounded-[8px] mt-2
                                    ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-[#4096F6] hover:bg-blue-600 shadow-md"}`}
                                >
                                    {loading ? "Please wait..." : "Continue"}
                                </button>
                            </div>

                            <p className="mt-8 text-[18px] font-[500] tracking-tight text-[#333333] mt-10">
                                Already have an account?{" "}
                                <button className="text-[#4096F6] font-[500] hover:underline">
                                    Login
                                </button>
                            </p>
                        </div>

                        <div className="flex-1 relative hidden lg:flex items-center justify-center">
                            <img src={Testbook} alt="Banner" className="w-full h-full object-cover" />
                        </div>
                    </div>
                </div>
            </div>

            <OTP
                isOtpOpen={showOtp}
                onOtpClose={() => setShowOtp(false)}
                loginMethod={loginMethod}
                identifier={identifier}
                onEdit={() => setShowOtp(false)}
            />
        </>
    );
};

export default Signup;
